function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M58.333 83.333c.534 0 1.067-.204 1.475-.608a2.084 2.084 0 000-2.946L23.783 43.754 59.808 7.729a2.084 2.084 0 00-2.946-2.946l-37.5 37.5a2.086 2.086 0 000 2.946l37.5 37.5c.409.408.942.608 1.475.608l-.004-.004z",
  fillRule: "nonzero"
});

var SvgChevronLeftinline = function SvgChevronLeftinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
};

export default SvgChevronLeftinline;